import { Component, Input, OnInit } from '@angular/core';
import { HeaderDetailsItem } from 'src/app/models/componentInterfaces';

@Component({
  selector: 'app-summary-details',
  templateUrl: './summary-details.component.html',
  styleUrls: ['./summary-details.component.scss']
})
export class SummaryDetailsComponent implements OnInit {

  @Input()summaryItems: HeaderDetailsItem[] = [];

  ngOnInit(): void {
  }

  itemClicked(item: HeaderDetailsItem) {
    if (item.action) {
      item.action();
    }
  }

}
